import { render, staticRenderFns } from "./fileJurisModal.vue?vue&type=template&id=2b199846&scoped=true&"
import script from "./fileJurisModal.vue?vue&type=script&lang=js&"
export * from "./fileJurisModal.vue?vue&type=script&lang=js&"
import style0 from "./fileJurisModal.vue?vue&type=style&index=0&id=2b199846&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b199846",
  null
  
)

export default component.exports